import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowUpLeftLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M15.173 7.117a1 1 0 0 1-.216 1.09l-2.668 2.668 4.917 4.918a1 1 0 0 1-1.414 1.414l-4.918-4.918-2.668 2.668A1 1 0 0 1 6.5 14.25V7.5a1 1 0 0 1 1-1h6.75a1 1 0 0 1 .924.617'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowUpLeftLine)
export default ForwardRef
